export enum Lang {
  auto = 'auto',
  zh = 'zh-CHS',
  en = 'en',
  ja = 'ja',
}
